// extracted by mini-css-extract-plugin
export var link = "_ry-0";